// The initial HTML owns the shared router-equivalent classifier and one-use
// secret closure. It executes before this bundle or any third-party resources.
export const isTikTokCallbackDocument = () => !!window.__tiktokCallback?.isCallbackDocument
    || !!window.__tiktokCallback?.isCallbackPath(window.location.pathname);
export const takeTikTokCallbackParameters = () => window.__tiktokCallback?.takeParameters() || {};
